import React,{useEffect, useState} from 'react'
import SimpleTable from "../../../../../../../components/simpleTable/SimpleTable";
import { useDispatch, useSelector } from 'react-redux';
import { deleteCurrency, getAllCurrency } from '../../../../../../../api/apiServices/currencyApi';
import CustomChip from "../../../../../../../components/customChip/CustomChip";
import CustomModal from "../../../../../../../components/customModal/CustomModal";
import CurrencyForm from './currency_form/CurrencyForm'
import './currencyLookUpStyle.css'
import CurrencyLookUpFilter from './CurrencyFilter';
import ResponseHandler from '../../../../../../../services/ResponseHandler';
function CurrencyLookUp() {
const dispatch=useDispatch()
const [open, setOpen] = useState(false);
const [existingValue,SetExistingValue]=useState(null)
const [rerenderUpdate,setrerenderUpdate]=useState(false)
const Currency=useSelector((state)=>state.lookUpStore.currencies)
    useEffect(() => {
        dispatch(getAllCurrency())
      }, [rerenderUpdate]);
      const Columns = [
        {
          title: "#",
          dataIndex: "key",
          key: "key",
        },
        {
          title: "Currency name",
          dataIndex: "currency_name",
          key: "currency_name",
        },
        {
          title: "Actions",
          dataIndex: "Actions",
          key: "Actions",
          action: (row) => (
            <div  className="currency_lookup_action_chipset">
              <CustomChip text="Edit" bgColor="#F8893C" color="white" onClick={()=>{
                SetExistingValue(row)
                handleClickOpen()
              }} />
              <CustomChip text="Delete" bgColor="#ED5967" color="white" onClick={()=>{
                dispatch(deleteCurrency(row.id)).then((response)=>{
                  ResponseHandler(response)
                  setrerenderUpdate(!rerenderUpdate)
                }).catch((error)=>{
                  ResponseHandler(error)
                })
              }}/>
            </div>
          ),
        },
      ];
     
      const Datas=()=>{
        const result= Currency && Currency.map((item,index)=>{
          return{
            key:index+1,
            id:item.cl_id,
            currency_name:item.cl_currency
          }
        })
        return result
      }
      const handleClickOpen = () => {
        setOpen(true);
      };
      const handleClose = (state) => {
        setOpen(state);
        SetExistingValue(null)
        setrerenderUpdate(!rerenderUpdate)
      };
  return (
    <div>
    <div className="currency_lookup_header">
       <div>
          <CurrencyLookUpFilter/>
       </div>
       <div>
       <button className="add_currency_button" onClick={()=>{handleClickOpen()}}>
          Add Currency
        </button>
       </div>
    </div>
    <CustomModal
          open={open}
          handleClose={handleClose}
          body={<CurrencyForm onClose={handleClose} existingvalue={existingValue}/>}
          title={existingValue?'Update Currency':"Add Currency"}
        />
     <SimpleTable columns={Columns} rows={Datas()}/>
  </div>
  )
}

export default CurrencyLookUp